export default __webpack_public_path__ + "static/media/avax.2cdf4f84.svg";